import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <footer className={`footer-footer ${props.rootClassName} `}>
      <div className="footer-inner">
        {/* Top section */}
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">Abhishek Palit</Link>
            <p className="footer-tagline">
              Architect & VDC Engineer advancing the built environment through
              design, technology, and sustainability.
            </p>
          </div>

          <div className="footer-columns">
            <div className="footer-column">
              <h4 className="footer-column-title">Navigate</h4>
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/projects" className="footer-link">Projects</Link>
              <Link to="/articles" className="footer-link">Articles</Link>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Connect</h4>
              <a href="https://www.linkedin.com/in/abhishek-palit/" target="_blank" rel="noreferrer noopener" className="footer-link">
                LinkedIn
              </a>
              <a href="https://github.com/abhipalit3" target="_blank" rel="noreferrer noopener" className="footer-link">
                GitHub
              </a>
              <a href="mailto:palit@stanford.edu" className="footer-link">
                Email
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom section */}
        <div className="footer-bottom">
          <span className="footer-copyright">{props.copyright || '©2025 Abhishek Palit'}</span>

          <div className="footer-social-icons">
            <a
              href="https://www.linkedin.com/in/abhishek-palit/"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-social-link"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 1024 1024" className="footer-icon">
                <path d="M384 384h177.106v90.782h2.532c24.64-44.194 84.958-90.782 174.842-90.782 186.946 0 221.52 116.376 221.52 267.734v308.266h-184.61v-273.278c0-65.184-1.334-149.026-96.028-149.026-96.148 0-110.82 70.986-110.82 144.292v278.012h-184.542v-576zM64 384h192v576h-192v-576zM256 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"></path>
              </svg>
            </a>
            <a
              href="https://github.com/abhipalit3"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-social-link"
              aria-label="GitHub"
            >
              <svg viewBox="0 0 1024 1024" className="footer-icon">
                <path d="M512 0c-282.77 0-512 229.23-512 512 0 226.18 146.7 418.11 350.12 485.85 25.6 4.73 35-11.09 35-24.63 0-12.2-0.47-52.56-0.69-95.32-142.45 30.95-172.52-60.34-172.52-60.34-23.28-59.17-56.86-74.91-56.86-74.91-46.47-31.78 3.51-31.12 3.51-31.12 51.4 3.62 78.47 52.79 78.47 52.79 45.67 78.23 119.78 55.64 148.95 42.54 4.62-33.09 17.86-55.66 32.51-68.44-113.73-12.93-233.22-56.86-233.22-253.14 0-55.93 20.01-101.66 52.79-137.48-5.29-12.96-22.87-65.06 4.99-135.59 0 0 43.04-13.78 140.97 52.52 40.89-11.37 84.73-17.06 128.28-17.26 43.53 0.2 87.38 5.89 128.31 17.26 97.83-66.3 140.82-52.52 140.82-52.52 27.91 70.53 10.33 122.63 5.06 135.59 32.84 35.82 52.72 81.55 52.72 137.48 0 196.81-119.78 240.08-233.79 252.75 18.37 15.87 34.72 47.08 34.72 94.89 0 68.52-0.61 123.72-0.61 140.59 0 13.63 9.24 29.58 35.15 24.58 203.27-67.81 349.83-259.67 349.83-485.8 0-282.77-229.23-512-512-512z"></path>
              </svg>
            </a>
            <a
              href="https://x.com/"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-social-link"
              aria-label="X"
            >
              <svg viewBox="0 0 24 24" className="footer-icon">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  rootClassName: '',
  copyright: '©2025 Abhishek Palit',
}

Footer.propTypes = {
  rootClassName: PropTypes.string,
  copyright: PropTypes.string,
}

export default Footer
